var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSettingIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3571_20726",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2731 6.53343L14.195 6.50488L13.8971 5.77972L13.9285 5.70454C14.8279 3.62425 14.7651 3.55859 14.6147 3.40823L13.4184 2.21296C13.3614 2.15997 13.2868 2.12983 13.209 2.12826C12.4907 2.301 11.8014 2.57733 11.1627 2.94858L11.0904 2.97999L10.3623 2.68212L10.3309 2.60694C9.49714 0.5 9.41244 0.5 9.204 0.5H7.50797C7.30144 0.5 7.20912 0.5 6.43439 2.6117L6.40583 2.68973L5.67488 2.99236L5.60636 2.96381C4.94031 2.63639 4.24337 2.37594 3.52581 2.18631C3.44798 2.18788 3.37345 2.21802 3.31643 2.27101L2.11245 3.47103C1.95256 3.63091 1.8964 3.69086 2.8434 5.72834L2.87672 5.80352L2.58357 6.52486L2.51124 6.55341C0.394531 7.37944 0.394531 7.46699 0.394531 7.68682V9.38265C0.394531 9.60248 0.394531 9.69098 2.51124 10.4656L2.58643 10.4942L2.88909 11.2184L2.85768 11.2936C1.95827 13.3738 2.01442 13.4328 2.16861 13.5899L3.36877 14.787C3.42697 14.8406 3.50289 14.8708 3.58197 14.8717C4.30001 14.6996 4.98929 14.4243 5.62825 14.0543L5.70058 14.021L6.43153 14.3236L6.46008 14.3988C7.29097 16.5 7.37853 16.5 7.58411 16.5H9.27824C9.49048 16.5 9.57804 16.5 10.3518 14.3883L10.3804 14.3103L11.1142 14.0076L11.1827 14.0362C11.8481 14.3652 12.5452 14.6257 13.2632 14.8137C13.3425 14.8137 13.4188 14.7834 13.4764 14.729L14.6795 13.5261C14.8298 13.3662 14.8955 13.3063 13.9447 11.2717L13.9114 11.1936L14.2074 10.4713L14.2797 10.4428C16.3945 9.60819 16.3945 9.52635 16.3945 9.30081V7.61449C16.3945 7.39562 16.3945 7.30807 14.2721 6.53343H14.2731ZM8.39501 10.6959C7.96092 10.6942 7.53706 10.564 7.17695 10.3216C6.81684 10.0792 6.53662 9.73562 6.37168 9.33413C6.20673 8.93265 6.16445 8.4913 6.25017 8.0658C6.3359 7.64031 6.54578 7.24975 6.85333 6.94344C7.16087 6.63712 7.55229 6.42878 7.97817 6.34473C8.40404 6.26067 8.84528 6.30466 9.24616 6.47115C9.64705 6.63764 9.98962 6.91916 10.2306 7.28017C10.4716 7.64117 10.6002 8.06548 10.6002 8.49952C10.6002 8.78868 10.5431 9.07499 10.4322 9.34203C10.3213 9.60907 10.1587 9.85158 9.95382 10.0556C9.74893 10.2597 9.50576 10.4213 9.23826 10.5312C8.97076 10.6411 8.6842 10.697 8.39501 10.6959Z",
    fill: "#594AA5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3571_20726)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.394531,
    y: 0.5,
    width: 16,
    height: 16,
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSettingIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/settingIcon.f01f0750.svg";
export { ForwardRef as ReactComponent };